import { gql } from "@apollo/client";

export const DELETE_FORM = gql`
  mutation DeleteForm($form_id: uuid!) {
    update_form_by_pk(
      pk_columns: { id: $form_id }
      _set: { status: Deleted, deleted_at: "now()" }
    ) {
      id
      status
    }
    delete_offer: update_offer(
      _set: { deleted_at: "now()", status: Declined }
      where: { form_id: { _eq: $form_id }, deleted_at: { _is_null: true } }
    ) {
      affected_rows
      returning {
        id
        form_id
        school_id
        grade_id
      }
    }
    delete_waitlist: update_waitlist(
      _set: { deleted_at: "now()", status: Withdrawn }
      where: { form_id: { _eq: $form_id }, deleted_at: { _is_null: true } }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;
